import React, { useEffect, useState }from 'react';
import axios from "axios";
import { axiosLink } from '../../axiosLink';
import Token from "../../Utils/Token"
import { useNavigate } from 'react-router-dom';
import PdfModal from '../PdfModal/PdfModal';

const CarrerDashboard = () => {
    const [data, setData] = useState();
    const [pdf, setPdf] = useState();
    const { activeToken } = Token();
    const navigate = useNavigate();
  
    useEffect(() => {
           axios.get(
            `${axiosLink}/career/all`,
            {
                headers: {
                Authorization: activeToken,
                'Content-Type': 'application/json',
                },
            }
        ).then((res) => {
            if(!res.data?.errMsg) {
                setData(res?.data)
            } else {
                navigate("/")
            }
        })
    }, [navigate, activeToken]);
    return (
        <>
            <h3>Carrer</h3>
            <PdfModal src={pdf} open={!!pdf} close={(e) => setPdf(e)} />
            <table className='w-100'>
                <tbody>
                <tr>
                    <th>Fullname</th>
                    <th>Description</th>
                    <th>Phone</th>
                    <th>E-mail</th>
                    <th>Pdf</th>
                    <th>State</th>
                    <th>Created date</th>
                </tr>
                {data && data?.map((el) => (
                    <tr key={el.id} style={{ borderBottom: "1pt solid black" }}>
                        <td>{el.fullname}</td>
                        <td>{el.text}</td>
                        <td>{el.phone}</td>
                        <td>{el.email}</td>
                        <td><button onClick={() => setPdf(el.file)}>View</button></td>
                        <td> {el.state}</td>
                        <td>{el.createdAt}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </>
  )
}

export default CarrerDashboard;